const paintingData = [
  {
    id: 1,
    year: "2021",
    boroughs: "Manhattan",
	coordinates: "40.832222,-73.940556",
	start: "9:33 AM",
	paints: "cadmium yellow light, mars red, cadmium red light, alizarin crimson, ultramarine blue, cobalt blue, viridian green, chrome green, ivory black",
	dimensions: "29 x 16",
	widths: "21, 22, 25, 30",
	heights: "1, 8, 11, 14, 15, 16", 
  },
  {
    id: 2,
    year: "2022",
    boroughs: "Manhattan",
	coordinates: "40.709167,-73.998056",
	start: "7:37 AM",
	paints: "titanium white, cadmium yellow light, yellow ochre, raw sienna, mars red, cadmium red light, alizarin crimson, ultramarine blue, chrome green, ivory black",
	dimensions: "30 x 28",
	widths: "26, 30",
	heights: "23, 26, 28"
  },
  {
    id: 3,
	year: "2022",
	boroughs: "Manhattan",
	coordinates: "40.789444, -73.981111",
	start: "11:08 AM",
	paints: "cadmium yellow medium, cadmium red medium, alizarin crimson, viridian green",
	dimensions: "12 x 15",
	widths: "6, 7, 9, 10, 11, 12",
	heights: "4, 11, 15",
  },
  {
    id: 4,
	year: "2022",
	boroughs: "Manhattan",
	coordinates: "40.808943, -73.949539",
	start: "8:16 AM",
	paints: "titanium white, cadmium yellow light, yellow ochre, raw sienna, cadmium red light, cadmium red medium, alizarin crimson, cobalt blue, viridian green, chrome green, ivory black",
	dimensions: "23 x 42",
	widths: "3, 5, 6, 23",
	heights: "3, 5, 9, 18, 42",
  },
  {
    id: 5,
	year: "2023",
	boroughs: "Manhattan",
	coordinates: "40.794843, -73.916347",
	start: "1:58 PM",
	paints: "raw sienna, mars red, cadmium red light, cadmium red medium, alizarin crimson, cobalt blue, viridian green, chrome green, ivory black",
	dimensions: "13 x 38",
	widths: "3, 4, 6, 8, 9, 12, 13",
	heights: "3, 8, 13, 38",
  },
  {
    id: 6,
	year: "2023",
	boroughs: "Manhattan",
	coordinates: "40.760613, -73.983477",
	start: "8:52 AM",
	paints: "cadmium yellow light, yellow ochre, raw sienna, mars red, cadmium red medium, alizarin crimson, ultramarine blue",
	dimensions: "34 x 26",
	widths: "26, 27, 33, 34",
	heights: "21, 22, 26"
  },
  {
    id: 7,
	year: "2023",
	boroughs: "Manhattan",
	coordinates: "40.712058, -73.993814",
	start: "9:07 AM",
	paints: "titanium white, mars red",
	dimensions: "28 x 40",
	widths: "4, 6, 28",
	heights: "24, 27, 29, 30, 38, 40"
  },
  {
    id: 8,
	year: "2023",
	boroughs: "Manhattan",
	coordinates: "40.755653, -73.970981",
	start: "4:43 PM",
	paints: "titanium white, mars red, cadmium red light, chrome green, ivory black",
	dimensions: "52 x 22",
	widths: "17, 23, 27, 52",
	heights: "16, 17, 20, 21, 22",
  },
  { 
    id: 9,
	year: "2023",
	boroughs: "Manhattan",
	coordinates: "40.758995, -74.001780",
	start: "3:53 PM",
	paints: "raw sienna, mars red, ivory black",
	dimensions: "28 x 20",
	widths: "15, 16, 18, 19, 28",
	heights: "6, 7, 8, 10, 15, 20"
  },
  {
    id: 10,
	year: "2023",
	boroughs: "Manhattan",
	coordinates: "40.766746, -73.968765",
	start: "8:06 AM",
	paints: "cadmium red light, cobalt blue, chrome green",
	dimensions: "19 x 22",
	widths: "3, 4, 5, 6, 9, 19",
	heights: "18, 19, 20, 22",
  },
  {
    id: 11,
	year: "2023",
	boroughs: "Manhattan, Queens",
	coordinates: "40.808510, -73.954945",
	start: "12:26 PM",
	paints: "cadmium yellow light",
	dimensions: "38 x 15",
	widths: "31, 38",
	heights: "12, 15"
  },
  {
    id: 12,
	year: "2024",
	boroughs: "Manhattan, Queens",
	coordinates: "40.722726, -73.978348",
	start: "3:28 PM",
	paints: "cadmium yellow light, raw sienna, mars red, cadmium red medium, ultramarine blue, cobalt blue, viridian green, chrome green, ivory black",
	dimensions: "29 x 46",
	widths: "9, 10, 11, 19, 29",
	heights: "33, 35, 46"
  },
  {
    id: 13,
	year: "2024",
	boroughs: "Manhattan, Queens",
	coordinates: "40.709700, -74.011056",
	start: "9:50 AM",
	paints: "titanium white, mars red, cadmium red light, alizarin crimson, viridian green",
	dimensions: "19 x 60",
	widths: "7, 10, 12, 15, 19",
	heights: "14, 18, 36, 60"
  },
  {
    id: 14,
	year: "2024",
	boroughs: "Manhattan, Queens",
	coordinates: "40.734970, -73.731313",
	start: "8:37 AM",
	paints: "mars red, cadmium red light, cadmium red medium, ultramarine blue, viridian green",
	dimensions: "17 x 13",
	widths: "3, 11, 17",
	heights: "6, 7, 10, 11, 13"
  },
  {
    id: 15,
	year: "2024",
	boroughs: "Manhattan, Queens",
	coordinates: "40.719394, -73.860074",
	start: "8:28 AM",
	paints: "raw sienna, viridian green, chrome green, ivory black",
	dimensions: "12 x 34",
	widths: "2, 4, 7, 12",
	heights: "30, 31, 33, 34"
  },
  {
    id: 16,
	year: "2024",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.871808, -73.829390",
	start: "11:26 AM",
	paints: "cadmium yellow light, cadmium yellow medium, cadmium red light, chrome green, ivory black",
	dimensions: "13 x 15",
	widths: "5, 6, 7, 13",
	heights: "12, 13, 15",
  },
  {
    id: 17,
	year: "2024",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.876333, -73.925661",
	start: "8:53 AM",
	paints: "cobalt blue",
	dimensions: "14 x 11",
	widths: "4, 6, 14",
	heights: "4, 9, 10, 11"
  },
  {
    id: 18,
    year: "2024",
    boroughs: "Manhattan, Queens, The Bronx",
    coordinates: "40.858486, -73.856181",
    start: "9:23 AM",
    paints: "cadmium red light, ultramarine blue",
    dimensions: "40 x 25",
    widths: "2, 5, 7, 9, 14, 40",
    heights: "18, 19, 22, 23, 25"
  },
  {
    id: 19,
	year: "2024",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.837182, -73.940182",
	start: "4:45 PM",
	paints: "titanium white, cadmium yellow medium, raw sienna, alizarin crimson, cobalt blue, ivory black",
	dimensions: "54 x 27",
	widths: "42, 44, 45, 54",
	heights: "15, 16, 19, 24, 25, 27",
  },
  {
    id: 20,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.842277, -73.785836",
	start: "9:48 AM",
	paints: "titanium white",
	dimensions: "23 x 26",
	widths: "11, 12, 14, 16, 23",
	heights: "12, 13, 17, 26"
  },
  {
    id: 21,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.824480, -73.824308",
	start: "2:34 PM",
	paints: "titanium white, cadmium yellow light, cadmium yellow medium, yellow ochre, mars red, cadmium red light, alizarin crimson, ultramarine blue, cobalt blue",
	dimensions: "35 x 26",
	widths: "15, 18, 20, 22, 25, 35",
	heights: "9, 13, 26"
  },
  {
    id: 22,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.858888, -73.770289",
	start: "8:57 AM",
	paints: "cadmium yellow medium",
	dimensions: "23 x 8",
	widths: "4, 8",
	heights: "19, 20, 21, 23"
  },
  {
    id: 23,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.783506, -73.983996",
	start: "9:14 AM",
	paints: "cadmium red medium, ultramarine blue, cobalt blue",
	dimensions: "25 x 12",
	widths: "20, 21, 25",
	heights: "2, 8, 10, 11, 12",
  },
  {
    id: 24,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.817019, -73.884542",
	start: "3:01 PM",
	paints: "titanium white, cadmium yellow light, cadmium yellow medium, yellow ochre, cadmium red light, ultramarine blue, viridian green, ivory black",
	dimensions: "25 x 24",
	widths: "2, 3, 8, 25",
	heights: "7, 9, 12, 18, 24",
  },
  {
    id: 25,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.894469, -73.869352",
	start: "2:36 PM",
	paints: "titanium white, cadmium yellow light, yellow ochre, raw sienna, cadmium red light, ultramarine blue, cobalt blue, chrome green, ivory black",
	dimensions: "25 x 9",
	widths: "1, 3, 7, 8, 15, 25",
	heights: "5, 7, 8, 9",
  },
  {
    id: 26,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.682491, -73.734137",
	start: "8:47 AM",
	paints: "titanium white, cadmium yellow light, alizarin crimson, chrome green, ivory black",
	dimensions: "28 x 9",
	widths: "2, 3, 9",
	heights: "11, 12, 28",
  },
  {
    id: 27,
	year: "2025",
	boroughs: "Manhattan, Queens, The Bronx",
	coordinates: "40.778639, -73.892072",
	start: "3:26 PM",
	paints: "titanium white, yellow ochre",
	dimensions: "28 x 38",
	widths: "6, 10, 13, 15, 16, 17",
	heights: "1, 29, 31, 32",
  }
]

export default paintingData;